(function () {
    const header = document.querySelector('.site-header--floating');
    if (!header) return;

    const body = document.body;

    // ✅ measure header height and set CSS var + body padding class
    const setHeaderHeight = () => {
        const h = header.offsetHeight || 0;
        document.documentElement.style.setProperty('--header-h', `${h}px`);
        body.classList.add('has-floating-header');
    };

    setHeaderHeight();

    let lastY = window.scrollY || 0;
    let ticking = false;

    const onScroll = () => {
        const y = window.scrollY || 0;

        // ✅ add shadow after small scroll
        if (y > 10) header.classList.add('is-sticky');
        else header.classList.remove('is-sticky');

        // ✅ desktop-only hide/show
        const isDesktop = window.matchMedia('(min-width: 992px)').matches;

        if (isDesktop) {
            const goingDown = y > lastY;

            // small deadzone to avoid jitter
            if (Math.abs(y - lastY) > 6) {
                if (goingDown && y > 120) header.classList.add('is-hidden');
                else header.classList.remove('is-hidden');
            }
        } else {
            // ✅ mobile: never hidden
            header.classList.remove('is-hidden');
        }

        lastY = y;
        ticking = false;
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(onScroll);
            ticking = true;
        }
    }, { passive: true });

    window.addEventListener('resize', setHeaderHeight);
})();
// Add your custom JS here.